<template>
    <div class="modal registerPopUs d-flex align-items-center justify-content-center">
        <div class="modal-dialog">
            <div class="modal-contents">
                <span class="demoCreatingMessage" v-text="message"></span>
                <AppLoader />
            </div>
        </div>
    </div>
</template>

<script>
import AppLoader from './AppLoader.vue';
export default {
    props:['message'],
    components: { AppLoader }
}
</script>